import script from "./ShoppingPreviewLazy.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShoppingPreviewLazy.vue?vue&type=script&lang=ts&setup=true"

import "./ShoppingPreviewLazy.vue?vue&type=style&index=0&id=32ff32f1&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32ff32f1"]])

export default __exports__